(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const initialized = new WeakSet();
  const drifting = new Set();
  let frame;
  const drift = () => {
    frame = null;
    if (reduced.matches) return;
    drifting.forEach(scene => {
      if (!scene.isConnected) { drifting.delete(scene); return; }
      const r = scene.getBoundingClientRect();
      if (r.bottom > 0 && r.top < innerHeight) scene.style.setProperty('--fd-drift', `${Math.max(-12, Math.min(12, -r.top * .025))}px`);
    });
  };
  const schedule = () => { if (!frame && !reduced.matches && drifting.size) frame = requestAnimationFrame(drift); };
  const init = (root = document) => {
    const scenes = root.matches?.('[data-fd-scene]') ? [root] : root.querySelectorAll('[data-fd-scene]');
    scenes.forEach(scene => {
      if (initialized.has(scene)) return;
      initialized.add(scene);
      if (scene.dataset.motion === 'cinematic') drifting.add(scene);
      const chooser = scene.querySelector('[data-chooser]');
      if (!chooser) return;
      const buttons = [...chooser.querySelectorAll('button')];
      const products = [...scene.querySelectorAll('.fd-product-scene')];
      if (buttons.length !== products.length || !products.length) return;
      const select = (index, animate = true) => {
        products.forEach((product, i) => { product.hidden = i !== index; product.classList.toggle('fd-entering', animate && i === index && scene.dataset.motion !== 'none'); });
        buttons.forEach((button, i) => { button.setAttribute('aria-pressed', String(i === index)); });
      };
      buttons.forEach((button, index) => button.addEventListener('click', () => select(index)));
      chooser.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const current = buttons.indexOf(document.activeElement);
        if (current < 0) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        buttons[index].focus(); select(index);
      });
      select(0, false); chooser.hidden = false; scene.classList.add('fd-ready');
      scene.addEventListener('shopify:block:select', event => {
        const product = event.target.closest('.fd-product-scene');
        const index = products.indexOf(product); if (index >= 0) select(index, false);
      });
    });
    schedule();
  };
  addEventListener('scroll', schedule, { passive: true });
  document.addEventListener('shopify:section:load', e => init(e.target));
  reduced.addEventListener('change', () => { drifting.forEach(scene => scene.style.removeProperty('--fd-drift')); schedule(); });
  init();
})();
